<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column label="日期" min-width="100px">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="WeekDay" label="星期" min-width="80px" />
      <el-table-column prop="SectionName" label="节次" />
      <el-table-column prop="ClassName" label="班级" min-width="100px" />
      <el-table-column prop="Teacher" label="任课教师" min-width="100px" />
      <el-table-column prop="RollCallTeacherName" label="最后点名教师" min-width="110px" />
      <!-- <el-table-column prop="NormalText" label="状态" min-width="60px" align="center" /> -->
      <el-table-column prop="Remark" label="备注" min-width="200px" show-overflow-tooltip />
      <el-table-column prop="RollCallTime" label="最后点名时间" min-width="160px" />
      <el-table-column prop="Subject" label="科目" min-width="100px" />
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      data: [],
      params: {},
      title: "导出 点名日志信息",
    };
  },
  methods: {
    getData(params) {
      this.params = this.$commonJs.obj.removeNullKey(params);
      this.$refs.dialog.isLoading = true;
      this.api.getLogListV2(this.params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>